import { useState, memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Downloader } from './downloader'
import { getValue } from './utils'

import { Button as ButtonComponent } from '../../buttons/button'
import { PB40T, PB80T } from '../../colors'
import { XlsIcon } from '../../icons/xls'

const Button = styled(ButtonComponent)`
  width: 156px;
  min-width: 140px;
  margin: 0 0 0 24px;
  border-color: ${PB40T};

  &::after {
    z-index: 1;
  }
  &:hover {
    border-color: ${props => (props.isDisabled ? PB40T : PB80T)};
  }
`
const ExportComponent = ({ data, headers, filename, onExportCsv }) => {
  const [isFetching, setIsFetching] = useState(null)
  const [blob, setBlob] = useState(null)
  const handleOnExportCsv = async () => {
    setIsFetching(true)

    try {
      setBlob(new Blob([await onExportCsv()], { type: 'text/csv;charset=utf-8;' }))
    } catch (err) {
      // Silently catch error
    } finally {
      setIsFetching(false)
    }
  }
  const createCsvBlob = () => {
    // So Excel understands UTF-8
    const bom = '\ufeff'
    let csv = headers.map(({ label }) => `"${label}"`).join(',')

    csv += '\n'

    data.forEach(row => {
      headers.forEach(({ id }, idx) => {
        const value = getValue(row, id)

        csv += idx < headers.length - 1 ? `"${value}",` : `"${value}"\n`
      })
    })

    setBlob(new Blob([`${bom}${csv}`], { type: 'text/csv;charset=utf-8;' }))
  }

  return (
    <>
      <Button
        size="small"
        isOutline={true}
        isDisabled={data ? !data.length : isFetching}
        icon={XlsIcon}
        onClick={onExportCsv ? handleOnExportCsv : createCsvBlob}>
        Export CSV
      </Button>
      {blob && (
        <Downloader
          blob={blob}
          filename={filename}
          onDownload={() => {
            setBlob(null)
          }}
        />
      )}
    </>
  )
}

ExportComponent.propTypes = {
  data: PropTypes.array,
  headers: PropTypes.array,
  filename: PropTypes.string.isRequired,
  onExportCsv: PropTypes.func
}

const Export = memo(ExportComponent)

export { Export }
